import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '../../../comum/material.module';
import { AppControlsModule } from '../controls/app.controls.module';
import { DbModule } from '../db/db.module';
import { DirectivesModule } from '../directives/directives.module';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { MainComponent } from './main/main.component';
import { MostrarProdutoCategoriaComponent } from './mostrar-produto-categoria/mostrar-produto-categoria.component';
import { MostrarProdutoFornecedorComponent } from './mostrar-produto-fornecedor/mostrar-produto-fornecedor.component';
import { MostrarProdutoSubCategoriaComponent } from './mostrar-produto-subCategoria/mostrar-produto-subCategoria.component';

import { CarrinhoComponent } from './carrinho/carrinho.component';
import { MenuComponent } from './menu/menu.component';
import { MeusPedidosComponent } from './meus-pedidos/meus-pedidos.component';
import { LocalidadeComponent } from './localidade/localidade.component';
import { SplashComponent } from './splash/splash.component';
import { ChatsModule } from '../../../chats/chats.module';
import { ChatMessagesComponent } from '../../../chats/chat-messages/chat-messages.component';
import { NaoEncontreiDialog } from './nao-encontrei/nao-encontrei';

import { LoginComponent } from './login/login.component';
import { CadastroLoginDialog } from './login/cadastro.login.dialog';
import { VerDocumentoComponent } from '../../../comum/controls/mat-ver-documento';
import { TermoPrivacidadeComponent } from './documentos/termo-privacidade';

export const routes: Routes = [
  { path: '', component: SplashComponent },
  { path: 'meusPedidos', component: MeusPedidosComponent },
  { path: 'splash', component: SplashComponent },
  { path: 'home', component: MenuComponent },
  { path: 'menu', component: MenuComponent },
  { path: 'main', component: MainComponent },
  {
    path: 'prod_fornec/:codigo', component: MostrarProdutoFornecedorComponent,
  },
  {
    path: 'prod_categ/:codigo', component: MostrarProdutoCategoriaComponent,
  },

  {
    path: 'fornecedor/:codigo', component: MostrarProdutoFornecedorComponent,
  },
  {
    path: 'categoria/:categoria', component: MostrarProdutoFornecedorComponent,
  },
  {
    path: 'subCategoria/:codigo', component: MostrarProdutoSubCategoriaComponent,
  },
  {
    path: 'produto/:codigo', component: MostrarProdutoFornecedorComponent,
  },
  {
    path: 'estouComSorte/:tipo', component: MostrarProdutoFornecedorComponent,
  },

  { path: 'carrinho', component: CarrinhoComponent },
  { path: 'mensagem', component: ChatMessagesComponent },
  { path: 'login', component:LoginComponent },
  { path: 'verDocumento/:nome', component:VerDocumentoComponent},
  { path: 'termoPrivacidade', component:TermoPrivacidadeComponent},

];


@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    RouterModule.forRoot(routes),
    MaterialModule,
    FlexLayoutModule,
    AppControlsModule,
    DbModule,
    DirectivesModule,
  ],
  exports: [
    MostrarProdutoFornecedorComponent,
    MostrarProdutoCategoriaComponent
  ],
  declarations: [
    CarrinhoComponent,
    LoginComponent,
    NaoEncontreiDialog,
    CadastroLoginDialog,
    MostrarProdutoFornecedorComponent,
    MainComponent,
    MostrarProdutoCategoriaComponent,
    MostrarProdutoSubCategoriaComponent,
    MenuComponent, MeusPedidosComponent,
    LocalidadeComponent, SplashComponent,
    VerDocumentoComponent,
    TermoPrivacidadeComponent  ]
  ,
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  entryComponents: [
    NaoEncontreiDialog,
    CadastroLoginDialog,
  ]
})
export class ViewsModule { }
